module.exports = __webpack_public_path__ + "img/verify-email-v2-dark.dcbc89c9.svg";